module.exports = __webpack_public_path__ + "img/qrcode@2x.40bba938.png";